import { Modal, Spinner, Text } from "@ui-kitten/components";
import i18n from "plugins/localization";
import React from "react";
import { ViewStyle } from "react-native";

interface FullScreenSpinnerProps {
  text?: string;
  style?: ViewStyle;
}
export default function FullScreenSpinner({
  text,
  style,
}: FullScreenSpinnerProps) {
  return (
    <Modal
      visible={true}
      backdropStyle={{ backgroundColor: "rgba(18,34,48,0.5)" }}
      style={[style, { alignItems: "center" }]}
    >
      <Spinner status="basic" size="giant"></Spinner>
      <Text style={{ marginTop: 10, color: "white" }}>
        {text ? text : i18n.t("common.loading")}
      </Text>
    </Modal>
  );
}
